import { z } from 'zod'

export const PASSWORD_HINT = 'Mínimo 8 caracteres, con mayúscula, minúscula y número'

// Required password — used when a password must always be provided (e.g. creating a user).
export const passwordSchema = z
  .string()
  .min(8, 'La contraseña debe tener al menos 8 caracteres')
  .regex(/[a-z]/, 'Debe incluir al menos una minúscula')
  .regex(/[A-Z]/, 'Debe incluir al menos una mayúscula')
  .regex(/[0-9]/, 'Debe incluir al menos un número')

// Optional password — an empty string means "no change" (edit forms), but any
// non-empty value must still satisfy the same complexity rules.
export const optionalPasswordSchema = z
  .string()
  .refine((value) => value === '' || passwordSchema.safeParse(value).success, {
    message: PASSWORD_HINT,
  })

// Extends a base object shape with an optional "change password" pair,
// requiring password and confirmPassword to match. Empty/empty is valid —
// it's how "leave blank to not change it" passes through.
export function withOptionalPasswordConfirmation<Shape extends z.ZodRawShape>(shape: Shape) {
  return z
    .object(shape)
    .extend({
      password: optionalPasswordSchema,
      confirmPassword: z.string(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: 'Las contraseñas no coinciden',
      path: ['confirmPassword'],
    })
}
